import { useNavigate } from 'react-router-dom';
import { UserImplementation } from '../user/user-implementation';
import { useAuthStore } from './useAuthStore';

export const useUpdateUserToken = () => {
  const authStore = useAuthStore();
  const navigate = useNavigate();
  const internalFunc = async () => {
    const token = await UserImplementation.updateToken();
    if (
      token.success &&
      token.data &&
      (!authStore.getIsAuthenticated() || !authStore.isInitialized)
    ) {
      authStore.authenticateUser(token.data);
    } else if (!token.success && !authStore.isInitialized) {
      authStore.unauthenticateUser();
    }
    navigate(0);
  };
  return internalFunc;
};
